import { FunctionComponent, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import { AnalyticsMetrics } from "../schema/analytics";
import { KpiKey } from "../utils/kpiFilterMap";
import { KpiRowConfig } from "../config/sections";
import { KpiBarRow } from "../components/KpiBarRow";
import { KpiSection } from "../components/KpiSection";

export interface KpiRowsSectionProps {
	titleKey: string;
	subtitleKey?: string;
	labelNamespace: string;
	rows: KpiRowConfig[];
	data: AnalyticsMetrics;
	onKpiClick: (kpi: KpiKey) => void;
	headerAccessory?: ReactNode;
	icon?: IconDefinition;
}

export const KpiRowsSection: FunctionComponent<KpiRowsSectionProps> = ({
	titleKey,
	subtitleKey,
	labelNamespace,
	rows,
	data,
	onKpiClick,
	headerAccessory,
	icon,
}) => {
	const { t } = useTranslation();

	return (
		<KpiSection
			headerAccessory={headerAccessory}
			icon={icon}
			subtitle={subtitleKey ? t(subtitleKey) : undefined}
			title={t(titleKey)}
		>
			{rows.map((row) => (
				<KpiBarRow
					key={row.i18nKey}
					barColorClass={row.barColorClass}
					clickKpi={row.clickKpi}
					emphasisPercent={row.emphasisPercent}
					isBaseline={row.isBaseline}
					label={t(`${labelNamespace}.${row.i18nKey}`)}
					total={data[row.totalField]}
					value={data[row.valueField]}
					onKpiClick={onKpiClick}
				/>
			))}
		</KpiSection>
	);
};
